// src/components/UI/UserAvatar.js
import React from 'react';

const UserAvatar = ({ avatarUrl, userName, className = '' }) => {
  const getInitials = (name) => {
    if (!name) return '';
    const words = name.trim().split(' ');
    return words.length === 1 
      ? words[0].slice(0, 2).toUpperCase() 
      : (words[0][0] + words[1][0]).toUpperCase();
  };

  return (
    <div className={`user-image ${className}`}>
      {avatarUrl && avatarUrl !== '/images/user-image.png' ? (
        <img 
          src={avatarUrl} 
          alt={userName || 'User Avatar'} 
          className="user-avatar"
        />
      ) : (
        <div className="user-initials">
          {getInitials(userName)}
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
